import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'validationInProgress',
  initialState: false,
  reducers: {
    setValidationInProgress(state, action: PayloadAction<boolean>) {
      return Boolean(action.payload);
    },
  },
});

export const { setValidationInProgress } = slice.actions;

export default slice.reducer;
